export var GinStepItemTextSize;
(function (GinStepItemTextSize) {
    GinStepItemTextSize["Small"] = "small";
    GinStepItemTextSize["Medium"] = "medium";
    GinStepItemTextSize["Large"] = "large";
})(GinStepItemTextSize || (GinStepItemTextSize = {}));
